
import { Component, Mixins } from "vue-property-decorator";
import { ILineBreakBehavior } from "../../../../../../documaker/domain/format/objects";
import { ILineBreakBehaviorPropertyEditable, instanceOfILineBreakBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class LineBreakBehaviorEditorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: ILineBreakBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ILineBreakBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isLineBreakBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfILineBreakBehaviorPropertyEditable(s) && s.lineBreakBehavior().isEditable(), false);
  }

  get lineBreakBehavior(): ILineBreakBehavior {
    return this.readPropertyOrDefault(s => s.lineBreakBehavior().getValue(), { isEnable: false });
  }

  set lineBreakBehavior(value: ILineBreakBehavior) {
    this.writePropertyWhenValid(s => s.lineBreakBehavior().setValue(value));
  }
}
